import { useEffect } from "react";

/**
 * Subscribe to the global `pda-scan-reset` CustomEvent. Fired by the
 * sticky-bottom Reset button when the operator wants to wipe a scan
 * session and start over (e.g. they scanned the wrong batch). Every page
 * that maintains its own scan accumulator should subscribe to this so a
 * single Reset clears both the breakdown summary AND the page's pending /
 * scanned list.
 */
export function usePdaScanReset(onReset, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const h = () => onReset();
    window.addEventListener("pda-scan-reset", h);
    return () => window.removeEventListener("pda-scan-reset", h);
  }, [enabled, onReset]);
}
